import { render, staticRenderFns } from "./IconSupporter.vue?vue&type=template&id=2e096dcc"
import script from "./IconSupporter.vue?vue&type=script&lang=js"
export * from "./IconSupporter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports